import React from 'react'
import { ACTIVITY_REPORT_MAP_COLORS } from '../unified/components/maps/constants/activityReportMap'

export default function SalesRouteLegend() {
  return (
    <div className="route-legend" aria-label="Leyenda del mapa">
      <strong>Leyenda:</strong>
      <div className="route-legend-items">
        <span>
          <i style={{ '--route-legend-color': ACTIVITY_REPORT_MAP_COLORS.geofenceInside }} />
          Dentro de Geocerca
        </span>
        <span>
          <i style={{ '--route-legend-color': ACTIVITY_REPORT_MAP_COLORS.geofenceOutside }} />
          Fuera de Geocerca
        </span>
        <span>
          <i style={{ '--route-legend-color': ACTIVITY_REPORT_MAP_COLORS.geofenceNoLocation }} />
          Cliente sin ubicación registrada
        </span>
      </div>
    </div>
  )
}
